<div class="spinner-wrapper"
     [ngClass]="{'fullscreen': fullscreen, 'opaque': opaque}">
  <ng-content></ng-content>
  <mat-spinner [diameter]="size"></mat-spinner>
</div>
